import { useNavigate } from 'react-router-dom';
import { BrainCircuit } from 'lucide-react';
import { PageHeader } from '@/components/shared/PageHeader';
import { PageLayout } from '@/components/shared/PageLayout';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';
import { useTranslation } from '@/hooks/useTranslation';
import { MLSignalRulView } from '../components/MLSignalRulView';
import { MLWearView } from '../components/MLWearView';

/** /ml: tool wear from the traceability history, and remaining life from live signals. */
export function MLRulPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <PageLayout contentClassName="max-w-6xl">
      <div className="flex flex-col gap-6">
        <PageHeader
          breadcrumb={[
            { label: t('common.brand'), onClick: () => navigate('/') },
            { label: t('machineLearning.modelPrediction.title') },
          ]}
          title={
            <span className="flex items-center gap-2">
              <BrainCircuit className="h-6 w-6 shrink-0 text-primary" aria-hidden />
              {t('machineLearning.modelPrediction.title')}
            </span>
          }
          description={t('machineLearning.modelPrediction.subtitle')}
        />

        <Tabs defaultValue="wear" className="flex flex-col gap-6">
          <TabsList className="w-fit rounded-lg bg-muted p-1">
            <TabsTrigger value="wear" data-testid="view-wear">
              {t('machineLearning.modelPrediction.views.wear')}
            </TabsTrigger>
            <TabsTrigger value="signals" data-testid="view-signals">
              {t('machineLearning.modelPrediction.views.signals')}
            </TabsTrigger>
          </TabsList>

          <TabsContent value="wear" className="focus-visible:outline-none">
            <MLWearView />
          </TabsContent>

          <TabsContent value="signals" className="focus-visible:outline-none">
            <MLSignalRulView />
          </TabsContent>
        </Tabs>
      </div>
    </PageLayout>
  );
}
